"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _alert = _interopRequireDefault(require("./alert"));
var _anchor = _interopRequireDefault(require("./anchor"));
var _autoComplete = _interopRequireDefault(require("./autoComplete"));
var _avatar = _interopRequireDefault(require("./avatar"));
var _badge = _interopRequireDefault(require("./badge"));
var _breadcrumb = _interopRequireDefault(require("./breadcrumb"));
var _button = _interopRequireDefault(require("./button"));
var _calendar = _interopRequireDefault(require("./calendar"));
var _card = _interopRequireDefault(require("./card"));
var _carousel = _interopRequireDefault(require("./carousel"));
var _cascader = _interopRequireDefault(require("./cascader"));
var _checkbox = _interopRequireDefault(require("./checkbox"));
var _collapse = _interopRequireDefault(require("./collapse"));
var _datePicker = _interopRequireDefault(require("./datePicker"));
var _descriptions = _interopRequireDefault(require("./descriptions"));
var _divider = _interopRequireDefault(require("./divider"));
var _drawer = _interopRequireDefault(require("./drawer"));
var _dropdown = _interopRequireDefault(require("./dropdown"));
var _empty = _interopRequireDefault(require("./empty"));
var _form = _interopRequireDefault(require("./form"));
var _grid = _interopRequireDefault(require("./grid"));
var _icon = _interopRequireDefault(require("./icon"));
var _image = _interopRequireDefault(require("./image"));
var _input = _interopRequireDefault(require("./input"));
var _inputNumber = _interopRequireDefault(require("./inputNumber"));
var _layout = _interopRequireDefault(require("./layout"));
var _list = _interopRequireDefault(require("./list"));
var _mentions = _interopRequireDefault(require("./mentions"));
var _menu = _interopRequireDefault(require("./menu"));
var _message = _interopRequireDefault(require("./message"));
var _modal = _interopRequireDefault(require("./modal"));
var _notification = _interopRequireDefault(require("./notification"));
var _pagination = _interopRequireDefault(require("./pagination"));
var _popconfirm = _interopRequireDefault(require("./popconfirm"));
var _popover = _interopRequireDefault(require("./popover"));
var _progress = _interopRequireDefault(require("./progress"));
var _radio = _interopRequireDefault(require("./radio"));
var _rate = _interopRequireDefault(require("./rate"));
var _result = _interopRequireDefault(require("./result"));
var _segmented = _interopRequireDefault(require("./segmented"));
var _select = _interopRequireDefault(require("./select"));
var _skeleton = _interopRequireDefault(require("./skeleton"));
var _slider = _interopRequireDefault(require("./slider"));
var _space = _interopRequireDefault(require("./space"));
var _spin = _interopRequireDefault(require("./spin"));
var _statistic = _interopRequireDefault(require("./statistic"));
var _steps = _interopRequireDefault(require("./steps"));
var _switch = _interopRequireDefault(require("./switch"));
var _table = _interopRequireDefault(require("./table"));
var _tabs = _interopRequireDefault(require("./tabs"));
var _tag = _interopRequireDefault(require("./tag"));
var _timeline = _interopRequireDefault(require("./timeline"));
var _timePicker = _interopRequireDefault(require("./timePicker"));
var _tooltip = _interopRequireDefault(require("./tooltip"));
var _transfer = _interopRequireDefault(require("./transfer"));
var _tree = _interopRequireDefault(require("./tree"));
var _treeSelect = _interopRequireDefault(require("./treeSelect"));
var _typography = _interopRequireDefault(require("./typography"));
var _upload = _interopRequireDefault(require("./upload"));
var ComponentDemos = {
  Alert: _alert.default,
  Anchor: _anchor.default,
  AutoComplete: _autoComplete.default,
  Avatar: _avatar.default,
  Badge: _badge.default,
  Breadcrumb: _breadcrumb.default,
  Button: _button.default,
  Calendar: _calendar.default,
  Card: _card.default,
  Carousel: _carousel.default,
  Cascader: _cascader.default,
  Checkbox: _checkbox.default,
  Collapse: _collapse.default,
  DatePicker: _datePicker.default,
  Descriptions: _descriptions.default,
  Dropdown: _dropdown.default,
  Empty: _empty.default,
  Form: _form.default,
  Grid: _grid.default,
  Icon: _icon.default,
  Image: _image.default,
  InputNumber: _inputNumber.default,
  Input: _input.default,
  Layout: _layout.default,
  List: _list.default,
  Mentions: _mentions.default,
  Modal: _modal.default,
  Notification: _notification.default,
  Pagination: _pagination.default,
  Popconfirm: _popconfirm.default,
  Popover: _popover.default,
  Radio: _radio.default,
  Rate: _rate.default,
  Select: _select.default,
  Skeleton: _skeleton.default,
  Slider: _slider.default,
  Spin: _spin.default,
  Statistic: _statistic.default,
  Switch: _switch.default,
  Table: _table.default,
  Tabs: _tabs.default,
  Tag: _tag.default,
  TimePicker: _timePicker.default,
  Timeline: _timeline.default,
  Tooltip: _tooltip.default,
  Transfer: _transfer.default,
  TreeSelect: _treeSelect.default,
  Tree: _tree.default,
  Typography: _typography.default,
  Upload: _upload.default,
  Divider: _divider.default,
  Space: _space.default,
  Menu: _menu.default,
  Steps: _steps.default,
  Segmented: _segmented.default,
  Drawer: _drawer.default,
  Message: _message.default,
  Result: _result.default,
  Progress: _progress.default
};
var _default = exports.default = ComponentDemos;